import {ReactElement} from 'react';
import {ButtonV2} from '../../atoms/ButtonV2/ButtonV2';
import {
  ButtonV2Size,
  ButtonV2Variant,
} from '../../atoms/ButtonV2/ButtonV2.enum';
import {ButtonV2Props} from '../../atoms/ButtonV2/ButtonV2Props.interface';

export interface DialogButtonProps extends ButtonV2Props {
  description?: string | ReactElement;
}

export function DialogButton({
  children,
  description,
  size = ButtonV2Size.Large,
  variant = ButtonV2Variant.Secondary,
  ...props
}: DialogButtonProps) {
  return (
    <ButtonV2 size={size} variant={variant} {...props}>
      <div className="flex flex-col items-center justify-center">
        {children}
        {description && (
          <div className="font-small2 mt-2pxr line-clamp-1 break-all">
            {description}
          </div>
        )}
      </div>
    </ButtonV2>
  );
}

export const DialogButtonType = (<DialogButton />).type;
